<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <feather-icon
          icon="KeyIcon"
          class="text-warning text-lighten-4 mb-2"
          size="70"
        />

        <h2 class="mb-1">دخول غير مصرح !</h2>
        <p class="mb-2">
          عفواُ! يبدو أنك لا تمتلك الصلاحيات اللازمة لعرض الصفحة.
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="getHomePath()"
        >
          عودة للرئيسية
        </b-button>

        <!-- image -->
        <b-img fluid :src="imgUrl" alt="Error page" />
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton, BImg } from "bootstrap-vue";
import store from "@/store/index";
import authHelpers from "@/utils/auth-helpers";
export default {
  components: {
    BLink,
    BButton,
    BImg,
  },
  data() {
    return {
      downImg: require("@/assets/images/pages/not-authorized.svg"),
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require("@/assets/images/pages/not-authorized-dark.svg");
        return this.downImg;
      }
      return this.downImg;
    },
  },
  methods: {
    getHomePath() {
      var isUserMinistry = authHelpers.isUserMinistry();
      var isUserTemp = authHelpers.isUserTemp();
      return isUserMinistry
        ? "/ministry"
        : isUserTemp
        ? "/temp-ngo"
        : "/ngo-profile";
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
